import { useEffect } from 'react';
import '../css/still.css';
import { NavLink } from 'react-router-dom';
const Fourthclass = () => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
        link.integrity = 'sha384-QWTK2YjpPpEj1SV5WaRU90FeRpok6Y...';
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link); // chiqishda tozalaydi
        };
    }, []);
    return (
        <>
            <section className="section-padding pt-0 mt-5">
                <div className="container">
                    <div className="row">
                        <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        <b>4-sinf <u>1-chorak</u></b>
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        {/* 1-mavzu */}
                                        <figure className="text-center">
                                            <blockquote className="blockquote">
                                                {/* <p>Mavzu: Gap va uning turlari</p> */}
                                            </blockquote>
                                            <NavLink to="/4-sinf/1-chorak/-/eng-oson">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                            <NavLink to="/4-sinf/1-chorak/-/oson">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                            <NavLink to="/4-sinf/1-chorak/-/sal-murakkab">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                        </figure>
                                        {/* 2-mavzu */}
                                        {/* <figure className="text-center">
                                            <blockquote className="blockquote">
                                                <p>Mavzu: Gap bo‘laklari</p>
                                            </blockquote>
                                            <NavLink to="/3-sinf/1-chorak/gap-bulaklari/eng-oson">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                            <NavLink to="/3-sinf/1-chorak/gap-bulaklari/oson">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                            <NavLink to="/3-sinf/1-chorak/gap-bulaklari/sal-murakkab">
                                                <h5>
                                                    <figcaption className="blockquote-footer">
                                                        “Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
                                                    </figcaption>
                                                </h5>
                                            </NavLink>
                                        </figure> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Fourthclass;